<script>
export default {
	name: 'PageAlert',
	components: {},
	props: {
		text: {
			type: String,
			required: true,
		},
		type: {
			type: String,
			default: 'primary',
		},
	},
	data() {
		return {
			classes: {
				primary: 'bg-main bg-opacity-10 border-main',
				error: 'bg-red bg-opacity-10 border-red',
			},
		}
	},
	computed: {
		getClasses() {
			return this.classes[this.type]
		},
	},
}
</script>

<template>
	<div
		:class="{ [getClasses]: true }"
		class="box-border px-[30px] py-[12px] shadow-main rounded-[10px] backdrop-blur-[10px] border-[1px] border-solid flex flex-wrap justify-between items-center gap-[15px]"
	>
		<div>
			<div class="font-main font-normal text-[14px] text-dark leading-[1.22]" v-html="text"></div>
		</div>
	</div>
</template>
